const ns = {}

ns.cdnUrl = 'http://47.99.147.147/cdn'

export default ns
